module.exports = __webpack_public_path__ + "static/media/3.7613f47f.png";